<template>
  <div :id="'label_' + id" class="condition-item">
    <el-date-picker
      v-model="val"
      @change="inputChange"
      type="datetimerange"
      range-separator="至"
      start-placeholder="开始日期"
      end-placeholder="结束日期"
      prefix-icon="none"
      :picker-options="pickerOptions"
      value-format="yyyy-MM-dd HH:mm:ss"
      :style="{ paddingleft: labelWidth + 'px' }"
    ></el-date-picker>
    <!-- <el-input
      v-model="val"
      :id="'label_' + id"
      @input="inputChange"
      class="condition-input input-normal"
      :placeholder="placeholder"
      size="small"
    ></el-input> -->
    <div v-if="id" :ref="'label_' + id" class="condition-item-label">
      {{ label }}
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      id: "",
      labelWidth: 0,
      val: [],
    };
  },
  model: {
    prop: "value",
    event: "change",
  },
  props: {
    value: Array,
    label: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
      default: "",
    },
    pickerOptions: {
      type: Object,
      default: () => {},
    },
  },
  mounted() {
    this.val = this.value;
    this.id = this.$rrj.uuid();
    this.$nextTick(() => {
      this.labelWidth = this.$refs["label_" + this.id].offsetWidth;
      for (let item of document.getElementById("label_" + this.id).children) {
        let arr = item.className.split(" ");
        if (arr.indexOf("el-date-editor") >= 0) {
          item.style.paddingLeft = this.labelWidth - 15 + "px";
        }
        console.log("item", item);
      }
      //   document.getElementById("label_" + this.id).children.style.paddingLeft =
      // this.labelWidth + 10 + "px";
    });
  },
  methods: {
    inputChange() {
      this.$emit("change", this.val);
    },
  },
};
</script>

<style lang="scss"></style>
